<template>
  <b-card no-body>
    <b-tabs pills card v-model="tabIndex">
      <!-- Maklumat Inisiatif Tab -->
      <b-tab title="Maklumat Inisiatif" active>
        <b-card-text>
          <form @submit.prevent="updateProject">
            <!-- Project Name -->
            <div class="mb-3">
              <label for="name" class="form-label font-weight-bold">Nama Inisiatif</label>
              <input type="text" class="form-control" id="name" v-model="project.project_name" placeholder="Nama Inisiatif"
                required />
            </div>
            <!-- Project Description -->
            <div class="mb-3">
              <label for="description" class="form-label font-weight-bold">Keterangan:</label>
              <textarea class="form-control" id="description" v-model="project.description" rows="3"
                placeholder="Keterangan Inisiatif" required></textarea>
            </div>


            <!-- Button -->
            <div class="d-flex justify-content-between">
              <b-button type="submit" variant="success">Kemaskini</b-button>
              <b-button variant="primary" @click="goBack">Kembali</b-button>
            </div>
          </form>
        </b-card-text>
      </b-tab>

      <!-- Maklumat Organisasi Tab -->
      <b-tab title="Maklumat Organisasi">
        <b-card-text>
          <form @submit.prevent="updateProject">
            <div class="mb-3">
              <label for="ministry" class="form-label font-weight-bold">Nama Organisasi</label>
              <input type="text" class="form-control" v-model="project.ministry" required />
            </div>
            <div class="mb-3">
              <label for="department" class="form-label font-weight-bold">Nama Jabatan</label>
              <input type="text" class="form-control" v-model="project.department" required />
            </div>
            <div class="mb-3">
              <label for="state" class="form-label font-weight-bold">Lokasi Inisiatif</label>
              <input type="text" class="form-control" v-model="project.state" required />
            </div>
            <div class="mb-3">
              <label for="team_leader" class="form-label font-weight-bold">Ketua Pasukan</label>
              <input type="text" class="form-control" v-model="project.team_leader" required />
            </div>
            <div class="mb-3">
              <label for="team_members" class="form-label font-weight-bold">Ahli Pasukan</label>
              <textarea class="form-control" v-model="project.team_members" rows="3" required></textarea>
            </div>
            <div class="d-flex justify-content-between">
              <b-button variant="secondary" @click="goBack">Kembali</b-button>
              <b-button type="submit" variant="primary">Kemaskini</b-button>
            </div>
          </form>
        </b-card-text>
      </b-tab>

      <!-- Kriteria Hemat Tab -->
      <b-tab title="Kriteria Hemat">
        <b-card-text>
          <ul class="list-group">
            <li v-for="(criterion, index) in criteria" :key="index"
              class="list-group-item d-flex justify-content-between align-items-center">
              <span>{{ criterion.name }}</span>
              <b-form-checkbox v-model="criterion.selected" switch></b-form-checkbox>
            </li>
          </ul>
          <div class="d-flex justify-content-between mt-3">
            <b-button variant="secondary" @click="goBack">Kembali</b-button>
            <b-button variant="primary" @click="nextTab">Seterusnya</b-button>
          </div>
        </b-card-text>
      </b-tab>

      <!-- Impak Projek Tab -->
      <b-tab title="Impak Projek">
        <b-card-text>
          <form @submit.prevent="updateProject">
            <div class="mb-3">
              <label for="before_project" class="form-label font-weight-bold">Sebelum Pelaksanaan Projek:</label>
              <textarea class="form-control" v-model="project.before_project" rows="3"></textarea>
            </div>
            <div class="mb-3">
              <label for="after_project" class="form-label font-weight-bold">Selepas Pelaksanaan Projek:</label>
              <textarea class="form-control" v-model="project.after_project" rows="3"></textarea>
            </div>
            <div class="d-flex justify-content-between">
              <b-button variant="secondary" @click="goBack">Kembali</b-button>
              <b-button type="submit" variant="primary">Simpan Projek</b-button>
            </div>
          </form>
        </b-card-text>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { baseURL } from '../../../services/baseURL';

export default {
  name: 'ProjectEdit',
  data() {
    return {
      tabIndex: 0, // For controlling active tab
      project: {
        project_name: '',
        description: '',
        status: '',
        start_date: '',
        end_date: '',
        budget: null,
        ministry: '',
        department: '',
        state: '',
        team_leader: '',
        team_members: '',
        before_project: '',
        after_project: '',
      },
      criteria: [
        { name: 'Hijrah Tata Kelola', selected: false },
        { name: 'Empati Rakyat', selected: false },
        { name: 'Minda Pekin', selected: false },
        { name: 'Apresiasi Inovasi', selected: false },
        { name: 'Telus Tadbiran', selected: false },
      ],
    };
  },
  computed: {
    formattedStartDate: {
      get() {
        return this.formatDateForDisplay(this.project.start_date);
      },
      set(value) {
        this.project.start_date = this.formatDateForDatabase(value);
      },
    },
    formattedEndDate: {
      get() {
        return this.formatDateForDisplay(this.project.end_date);
      },
      set(value) {
        this.project.end_date = this.formatDateForDatabase(value);
      },
    },
  },
  mounted() {
    this.fetchProjectDetails();
  },
  methods: {
    async fetchProjectDetails() {
      const projectId = this.$route.params.id;
      // const response = await axios.get(`http://localhost/hemat-b/api/papar_projek_id.php?id=${projectId}`);
      const response = await axios.get(baseURL + `/papar_projek_id.php?id=${projectId}`);
      // const url = baseURL + '/api_profile.php';

      if (response.data && response.data.status !== 'error') {
        this.project = response.data[0];
      }
    },
    formatDateForDisplay(dateString) {
      if (!dateString) return '';
      const [year, month, day] = dateString.split('-');
      return `${day}-${month}-${year}`;
    },
    formatDateForDatabase(dateString) {
      if (!dateString) return '';
      const [day, month, year] = dateString.split('-');
      return `${year}-${month}-${day}`;
    },
    async updateProject() {
      const payload = {
        id: this.$route.params.id,
        project_name: this.project.project_name,
        description: this.project.description,
        status: this.project.status,
        start_date: this.formatDateForDatabase(this.formattedStartDate),
        end_date: this.formatDateForDatabase(this.formattedEndDate),
        budget: this.project.budget,
        ministry: this.project.ministry,
        department: this.project.department,
        state: this.project.state,
        team_leader: this.project.team_leader,
        team_members: this.project.team_members,
        before_project: this.project.before_project,
        after_project: this.project.after_project,
      };
      try {
        // const response = await axios.post('http://localhost/hemat-b/api/kemaskini_projek.php', payload);
        const response = await axios.post(baseURL + '/kemaskini_projek.php', payload);

        if (response.data.status === 'success') {
          Swal.fire({
            title: 'Projek telah dikemaskini!',
            icon: 'success',
            confirmButtonText: 'OK',
          });
        }
      } catch (error) {
        Swal.fire({
          title: 'Ralat berlaku!',
          icon: 'error',
          text: 'Ralat berlaku semasa mengemaskini projek. Sila cuba lagi.',
          confirmButtonText: 'OK',
        });
      }
    },
    goBack() {
      this.$router.push('/senarai-projek');
    },
  },
};
</script>
